// UMD PATTERN
( function(root, factory) {
    if ( typeof define === 'function' && define.amd) {
        define('mmc.libs.TrackingHelper',['jquery'], factory);
    } else if ( typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    } else {
        if ( typeof root.MMCLIBS === 'object') {
            root.MMCLIBS.TrackingHelper = factory(root.$);
        } else {
            root.TrackingHelper = factory(root.$);
        }
    }
}(this, function($) {
// END UMD-PATTERN

    'use strict';

    // TrackingHelper Constructor
    function TrackingHelper(settings) {

        // TrackingHelper MainModule
        var trackingHelper = {
            _settings : {},
            _DOM : {},
            _methods : [],

            /**
             *
             * @method public
             * initialize trackingHelper instance
             */
            initialize : function(settings) {
                var key,
                    trackingMethod;
                this._settings = $.extend(true, {}, TrackingHelper.defaults, settings);
                this._methods = [];

                if (this._settings.container instanceof HTMLElement) {
                    this._DOM.$el = $(this._settings.container);
                } else if ( this._settings.container === null || this._settings.container === '' || ( typeof this._settings.container !== 'object' && typeof this._settings.container !== 'string' ) ) {
                    this._DOM.$el = $(document);
                } else {
                    this._DOM.$el = $(this._settings.container);
                }

                if (this._settings.clean === true) {
                    this.cleanTrackingName();
                }

                // ENABLE TRACKING METHODS
                for (key in this._settings.trackingMethods) {
                    trackingMethod = this._settings.trackingMethods[key];
                    if ( typeof trackingMethod === 'function') {
                        this._methods.push(trackingMethod);
                    }
                }

                this.initTrackingClickListener();
            },

            /**
             *
             * @method public
             * re-initialize all tracking click-handlers on all elements with dataTrackingType
             */
            initTrackingClickListener : function() {

                this._DOM.$el.find('[data-' + this._settings.dataTrackingName + ']').off('click.trackinghelper', this.onClickTrackingElement).on('click.trackinghelper', this.onClickTrackingElement);
            },

            /**
             *
             * @method private
             */
            onClickTrackingElement : function(e) {
                if ( typeof e.originalEvent === 'undefined') {
                    return;
                }

                var $element = $(this);

                trackingHelper.track({
                    type : $element.attr('data-' + trackingHelper._settings.dataTrackingType),
                    category : $element.attr('data-' + trackingHelper._settings.dataTrackingCategory),
                    action : $element.attr('data-' + trackingHelper._settings.dataTrackingAction),
                    name : $element.attr('data-' + trackingHelper._settings.dataTrackingName),
                    nonInteraction : $element.is('[data-' + trackingHelper._settings.dataTrackingNonInteraction + ']')
                });
            },

            /**
             * track using all initialized methods
             *
             * @method public
             * @param options
             *     type - enum(pageview, event) - required - deprecated enums: trackNOPV, trackSubPageView,
             * trackExternalLink
             *     category - enum() - optional
             *     action - enum() - optional
             *     name - string - required
             *     nonInteraction - boolean - optional
             */
            track : function(options) {
                if ( typeof options !== 'object') {
                    options = {
                        type : arguments[0],
                        name : arguments[1]
                    };
                }

                if ( typeof options.type !== 'string' || options.type === 'trackNOPV' || options.type === 'trackExternalLink') {
                    options.type = 'event';
                } else if (options.type === 'trackSubPageView') {
                    options.type = 'pageview';
                }

                for (var tracker in this._methods) {
                    this._methods[tracker].call(this, options);
                }
            },

            /**
             *
             * @method private
             */
            cleanTrackingName : function() {
                var that = this;
                this._DOM.$el.find('[data-' + this._settings.dataTrackingName + ']').each(function() {
                    var trackingName = $(this).attr('data-' + that._settings.dataTrackingName);
                    trackingName = trackingName.replace(/\s+/g, '-').toLowerCase();
                    $(this).attr('data-' + that._settings.dataTrackingName, trackingName);
                });
            },

            /**
             * concat the two strings and assert that there is exactly one / between them
             *
             * @method private
             * @param string a
             * @param string b
             */
            concatTrackingStrings : function(a, b) {
                if ( typeof a !== 'string' || typeof b !== 'string') {
                    return '';
                }
                return a.replace(/(\/)+$/, '') + '/' + b.replace(/^(\/)+/, '');
            }
        };
        // END TrackingHelper MainModule

        // INIT TRACKING HELPER
        trackingHelper.initialize(settings);

        return trackingHelper;
    }

    // DEFAULT SETTINGS
    TrackingHelper.defaults = {
        container : document, // container for tracking clickhandler
        clean : false, // replaces spaces with "-" in trackingname-attributes

        prefix : '', // tracking prefix, prepended to non-pageviews (only when using trackOmniture)
        pageName : '', // prefix for sub-pageview tracking
        trackingCategory : 'Global', // used w/ analytics.js and GTM
        trackingAction : 'Global', // used w/ analytics.js and GTM

        dataTrackingType : 'tracking-type',
        dataTrackingCategory : 'tracking-category',
        dataTrackingAction : 'tracking-action',
        dataTrackingName : 'tracking-name',
        dataTrackingNonInteraction : 'tracking-non-interaction',

        trackingMethods : {

            /**
             * track w/ Adobe SiteCatalyst
             *
             * @method public
             * @param options
             *     type - enum(pageview, event) - required
             *     name - string - required
             */
            trackOmniture : function(options) {
                var method;
                if (options.type === 'pageview') {
                    method = 'trackSubPageView';
                } else {
                    method = 'trackNOPV';
                    options.name = (this._settings.prefix !== '') ? this.concatTrackingStrings(this._settings.prefix, options.name) : options.name;
                }

                try {
                    if ( typeof window.Omniture[method] !== 'function') {
                        window.console && window.console.log('TRACKINGHELPER WARNING: method "' + method + '" does not exist on Omniture!');
                    } else {
                        window.console && window.console.log('TRACKINGHELPER: Omniture Tracking: ' + method + ', ' + options.name);
                        if (options.nonInteraction === true) {
                            window.console && window.console.log('TRACKINGHELPER NOTICE: nonInteraction parameter ignored, Omniture doesn\'t support this feature.');
                        }
                        window.Omniture[method].call(null, options.name);
                    }
                } catch(e) {
                    window.console && window.console.log('TRACKINGHELPER ERROR: unknown Omniture error, maybe no surrounding page?');
                }
            },

            /**
             * track Google Analytics via generic GTM settings. you need to have according GTM Tags and Macros
             *
             * @method public
             * @param options
             *     type - enum(pageview, event) - required
             *     category - enum() - optional
             *     action - enum() - optional
             *     name - string - required
             *     nonInteraction - boolean - optional
             */
            trackGenericGTM : function(options) {
                var trackingObject = {};

                if (options.type === 'pageview') {
                    trackingObject.event = 'Virtual Pageview';
                    trackingObject.pageNameVirtual = (this._settings.pageName !== '') ? this.concatTrackingStrings(this._settings.pageName, options.name) : options.name;
                } else {
                    trackingObject.event = 'ga_event';
                    trackingObject.eventCategory = ( typeof options.category === 'string') ? options.category : this._settings.trackingCategory;
                    trackingObject.eventAction = ( typeof options.action === 'string') ? options.action : this._settings.trackingAction;
                    trackingObject.eventLabel = options.name;
                    trackingObject.eventNonInteraction = false;

                    if (options.nonInteraction === true) {
                        trackingObject.eventNonInteraction = true;
                    }
                }

                try {
                    if ( typeof window.dataLayer === 'undefined') {
                        window.console && window.console.log('TRACKINGHELPER ERROR: GTM dataLayer object was not found!');
                    } else {
                        window.console && window.console.log('TRACKINGHELPER INFO: GTM Tracking: ', trackingObject);
                        window.dataLayer.push(trackingObject);
                    }
                } catch(e) {
                    window.console && window.console.log('TRACKINGHELPER ERROR: GTM unknown error!');
                }
            },

            /**
             * track Google Analytics via ga.js
             *
             * @method public
             * @param options
             *     type - enum(pageview, event) - required
             *     category - enum() - optional
             *     name - string - required
             *     nonInteraction - boolean - optional
             */
            trackGAJS : function(options) {

                var trackingMethod,
                    trackingName,
                    trackingCategory = '';

                if (options.type === 'pageview') {
                    trackingMethod = '_trackPageview';
                    trackingName = (this._settings.pageName !== '') ? this.concatTrackingStrings(this._settings.pageName, options.name) : options.name;
                } else {
                    trackingMethod = '_trackEvent';
                    trackingName = options.name;
                    trackingCategory = ( typeof options.category === 'string') ? options.category : this._settings.trackingCategory;
                }

                try {
                    if ( typeof _gaq === 'undefined') {
                        window.console && window.console.log('TRACKINGHELPER WARNING: GA: the "_gaq" object was not found!');
                    } else {
                        if (options.type === 'pageview') {
                            window._gaq.push([trackingMethod, trackingName]);
                        } else if (options.nonInteraction === true) {
                            //No need to reset nonInteraction property as it will not be stored for future objects being pushed
                            window._gaq.push([trackingMethod, trackingCategory, trackingName, '', 0, true]);
                        } else {
                            window._gaq.push([trackingMethod, trackingCategory, trackingName]);
                        }
                        window.console && window.console.log('TRACKINGHELPER: ga.js Tracking: ' + trackingMethod + ', ' + trackingCategory + ', ' + trackingName);
                    }
                } catch(e) {
                    window.console && window.console.log('TRACKINGHELPER ERROR: ga.js unknown error!');
                }
            },

            /**
             * track Google Analytics via analytics.js
             *
             * @method public
             * @param options
             *     type - enum(pageview, event) - required
             *     category - enum() - optional
             *     name - string - required
             *     nonInteraction - boolean - optional
             */
            trackAnalyticsJS : function(options) {

                var trackingMethod,
                    trackingName,
                    trackingCategory = '',
                    trackingAction = '',
                    trackingOptions = {};

                if (options.type === 'pageview') {
                    trackingMethod = '_trackPageview';
                    trackingName = (this._settings.pageName !== '') ? this.concatTrackingStrings(this._settings.pageName, options.name) : options.name;
                } else {
                    trackingMethod = '_trackEvent';
                    trackingName = options.name;
                    trackingCategory = ( typeof options.category === 'string') ? options.category : this._settings.trackingCategory;
                    trackingAction = ( typeof options.action === 'string') ? options.action : this._settings.trackingAction;
                    trackingOptions.eventNonInteraction = (options.nonInteraction === true) ? 1 : 0;
                }

                try {
                    if ( typeof ga === 'undefined') {
                        window.console && window.console.log('TRACKINGHELPER WARNING: analytics.js: the "ga" object was not found!');
                    } else {
                        if (options.type === 'pageview') {
                            window.ga('send', 'pageview', trackingName);
                        } else {
                            window.ga('send', 'event', trackingCategory, trackingAction, trackingName, trackingOptions);
                        }
                        window.console && window.console.log('TRACKINGHELPER: analytics.js Tracking: ' + trackingMethod + ', ' + trackingCategory + ', ' + trackingAction + ', ' + trackingName);
                    }
                } catch(e) {
                    window.console && window.console.log('TRACKINGHELPER ERROR: analytics.js unknown error!');
                }
            }
        }
    };

    return TrackingHelper;
}));

